/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Mastergroup1Inputs */



/**
* | output |
* | --- |
* | "Priority group" |
*
* @param {Br_History_Key_Mastergroup1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_mastergroup1 = /** @type {((inputs?: Br_History_Key_Mastergroup1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Mastergroup1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Priority group")
	return /** @type {LocalizedString} */ ("Groupe prioritaire")
});
export { br_history_key_mastergroup1 as "br_history_key_masterGroup" }